export const rpmEventsData = [
  {
    name: 'Service Initiation',
    id: 8,
    CPT: '99453',
    claimAmount: 19.04,
  },
  {
    name: 'Data Transmission',
    id: 9,
    CPT: '99454',
    claimAmount: 55.72,
  },
];
